import { Transactions } from '@sorare/marketplace/src/components/player/Transactions';

import { useLayoutData } from 'pages/players/$slug/layout';

const TransactionsPage = () => {
  const { player } = useLayoutData();

  return <Transactions anyPlayer={player} />;
};

export default TransactionsPage;
